<template>
  <div>
    <div style="align-items: start !important" class="row">
      <div
        style="background-color: #f2f2f2; padding: 10px; border-radius: 10px"
        class="col-md-8"
      >
        <div class="row">
          <div class="col-md-4">
            <div>
              <h5 class="titleChartMoonshot">FINANCIAL IMPACT PIPELINE</h5>
            </div>
            <div class="m-t-40 container-cash-cart">
              <div
                v-for="(item, id) in dataProfit"
                :key="id"
                :class="{ clicked: item.clicked }"
                style="cursor: pointer; height: 100px"
                class="item card card_white mb_12"
                @click="detailItem(item)"
              >
                <div class="sub_title_2">
                  {{ item.metricName }} {{ item.currency }}
                </div>
                <div
                  style="justify-content: space-between"
                  class="d-flex align-items-center"
                >
                  <div class="data_text">{{ item.value }} {{ item.unit }}</div>
                </div>
                <div style="color: #7a7a7a; font-size: small">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div style="text-align: right" class="header-right-chart">
              <div>
                <button
                  @click="monthly"
                  class="btn btn-square btn-disable right-radius"
                  :class="{ 'btn-info': !isActiveMonth }"
                  type="button"
                  title="btn btn-square btn-primary"
                >
                  Current
                </button>
                <button
                  @click="monthly"
                  :class="{ 'btn-info': isActiveMonth }"
                  class="btn btn-square btn-disable left-radius"
                  type="button"
                  title="btn btn-square btn-primary"
                >
                  Past 3 Months
                </button>
              </div>
            </div>
            <div style="justify-content: space-between; display: flex"></div>
            <div class="card-body">
              <apexchart
                height="390"
                width="400px"
                type="rangeBar"
                :options="options3"
                :series="series3"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div
          style="
            background-color: #f2f2f2;
            padding-top: 20px;
            border-radius: 10px;
          "
          class="card"
        >
          <div style="background-color: #f2f2f2" class="card-header">
            <div class="container-header">
              <div class="text">
                <h6 class="title">IMPROVEMENT ASPIRATION</h6>
              </div>
            </div>
          </div>
          <div style="padding: 10px !important" class="card-body">
            <div
              v-for="(item, id) in dataImproved"
              :key="id"
              class="card card_white mb_12"
            >
              <div class="sub_title_2">{{ item.metricName }}</div>
              <div
                style="justify-content: space-between"
                class="d-flex align-items-center"
              >
                <div class="data_text">{{ item.value }}</div>
                <div style="flex: 1; text-align: right" class="d-flex ms-2">
                  <div
                    v-if="item.achievement !== null"
                    class="d-inline-flex align-items-center me-2"
                    :class="
                      item.achievementStatus === 'DOWN'
                        ? 'badge_red'
                        : 'badge_green'
                    "
                  >
                    <IconSvg
                      :color="
                        item.achievementStatus === 'DOWN' ? 'red' : 'green'
                      "
                      :type="
                        item.achievementStatus === 'DOWN'
                          ? 'arrow_down'
                          : 'arrow_up'
                      "
                    />
                    <div
                      class="data_detil"
                      :style="
                        item.achievementStatus === 'DOWN'
                          ? 'color: red'
                          : 'color:green'
                      "
                    >
                      {{ item.achievement }}
                    </div>
                  </div>
                  <!-- <div
                          class="d-inline-flex align-items-center badge_black"
                        >
                          <IconSvg :color="'black'" :type="'chart_up'" />
                          <div class="data_detil" style="color: black">41%</div>
                        </div> -->
                </div>
              </div>
              <div class="m-t-10 m-b-25" style="color: #4e4e4e">
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            background-color: #f2f2f2;
            padding-top: 20px;
            border-radius: 10px;
          "
          class="card"
        >
          <div style="background-color: #f2f2f2;" class="card-header">
            <div class="container-header">
              <div class="text">
                <h6 class="title">NET ZERO ASPIRATION</h6>
              </div>
            </div>
          </div>
          <div style="padding: 10px !important" class="card-body">
            <div
              v-for="(item, id) in dataNetZero"
              :key="id"
              class="card card_white mb_12"
            >
              <div class="sub_title_2">{{ item.metricName }}</div>
              <div
                style="justify-content: space-between"
                class="d-flex align-items-center"
              >
                <div class="data_text">{{ item.value }}</div>
                <div style="flex: 1; text-align: right" class="d-flex ms-2">
                  <div
                    v-if="item.achievement !== null"
                    class="d-inline-flex align-items-center me-2"
                    :class="
                      item.achievementStatus === 'DOWN'
                        ? 'badge_red'
                        : 'badge_green'
                    "
                  >
                    <IconSvg
                      :color="
                        item.achievementStatus === 'DOWN' ? 'red' : 'green'
                      "
                      :type="
                        item.achievementStatus === 'DOWN'
                          ? 'arrow_down'
                          : 'arrow_up'
                      "
                    />
                    <div
                      class="data_detil"
                      :style="
                        item.achievementStatus === 'DOWN'
                          ? 'color: red'
                          : 'color:green'
                      "
                    >
                      {{ item.achievement }}
                    </div>
                  </div>
                  <!-- <div
                          class="d-inline-flex align-items-center badge_black"
                        >
                          <IconSvg :color="'black'" :type="'chart_up'" />
                          <div class="data_detil" style="color: black">41%</div>
                        </div> -->
                </div>
              </div>
              <div class="m-t-10 m-b-25" style="color: #4e4e4e">
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IconSvg from "@/components/IconSvg.vue";
export default {
  props: ["dataProfit", "options3", "series3", "dataImproved", "dataNetZero"],
  components: {
    IconSvg,
  },
  data() {
    return {
      isActiveMonth: false,
    };
  },
  methods: {
    getData() {
      const data = this.dataProfit[0];
      this.dataProfit.forEach((e) => {
        if (e.metricId === data.metricId) {
          e.clicked = true;
        } else {
          e.clicked = false;
        }
      });
    },
    detailItem(x) {
      this.dataProfit.forEach((e) => {
        if (e.metricId === x.metricId) {
          e.clicked = true;
          this.$emit("sendData", x.metricId);
        } else {
          e.clicked = false;
        }
      });
    },
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
    },
  },
};
</script>
<style scoped>
.btn-disable {
  background-color: #e9e9e9;
}
.right-radius {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.left-radius {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.clicked {
  border-color: #00a3e9;
  background-color: #ecf9ff;
}
</style>
